import { render, staticRenderFns } from "./StickyColumns.vue?vue&type=template&id=7c5d6c6e"
import script from "./StickyColumns.vue?vue&type=script&lang=js"
export * from "./StickyColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports